import React from 'react';
import { 
  BarChart3, 
  Search, 
  FileText, 
  Brain, 
  Target, 
  Settings, 
  Zap,
  TrendingUp,
  Users,
  Globe
} from 'lucide-react';

interface SidebarProps {
  currentPage: string;
  setCurrentPage: (page: string) => void;
}

const menuItems = [
  { id: 'dashboard', label: 'Kojelauta', icon: BarChart3 },
  { id: 'analytics', label: 'Analytiikka', icon: TrendingUp },
  { id: 'visibility', label: 'Näkyvyys', icon: Zap },
  { id: 'mentions', label: 'Maininnat', icon: Search },
  { id: 'competitors', label: 'Kilpailuasema', icon: Target },
  { id: 'datasets', label: 'Koulutusdata', icon: Globe },
  { id: 'optimize', label: 'Optimointi', icon: Brain },
  { id: 'content-audit', label: 'Sisällön auditointi', icon: FileText },
  { id: 'website-audit', label: 'Tekninen auditointi', icon: Search },
  { id: 'prompt-management', label: 'Promptit', icon: Brain },
  { id: 'guides', label: 'Oppaat', icon: FileText },
  { id: 'export', label: 'Datan vienti', icon: Users },
  { id: 'settings', label: 'Asetukset', icon: Settings },
  { id: 'billing', label: 'Laskutus', icon: Users },
];

export default function Sidebar({ currentPage, setCurrentPage }: SidebarProps) {
  return (
    <div className="w-64 min-h-screen bg-slate-900/80 backdrop-blur-xl border-r border-slate-700/50">
      <div className="p-6">
        <div className="flex items-center space-x-3 mb-8">
          <div className="w-10 h-10 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center">
            <Zap className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-white">LLM SEO</h1>
            <p className="text-sm text-slate-400">Tekoäly-optimointi</p>
          </div>
        </div>

        <nav className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPage === item.id;
            
            return (
              <button
                key={item.id}
                onClick={() => setCurrentPage(item.id)}
                className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 group ${
                  isActive
                    ? 'bg-gradient-to-r from-purple-600 to-purple-500 text-white shadow-lg shadow-purple-500/25'
                    : 'text-slate-300 hover:text-white hover:bg-slate-800/50'
                }`}
              >
                <Icon className={`w-5 h-5 ${isActive ? 'text-white' : 'text-slate-400 group-hover:text-white'}`} />
                <span>{item.label}</span>
                {isActive && (
                  <div className="ml-auto w-2 h-2 bg-white rounded-full animate-pulse" />
                )}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
